var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHealthCare = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#EDEFF2",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.485 5.576c-.511.245-1.58.68-2.452 1a33 33 0 0 1-6.01 1.57c-.66.104-.754.13-.843.228l-.1.111.015 4.385c.017 4.778.01 4.637.278 5.724.858 3.485 3.482 6.093 7.502 7.459.743.252 1.743.506 1.998.507.24 0 1.114-.212 1.842-.45 3.334-1.084 5.811-3.097 7.039-5.721.374-.8.617-1.594.799-2.607.092-.514.095-.642.11-4.908.014-4.377.014-4.381-.076-4.497-.067-.085-.147-.124-.298-.144-2.752-.378-5.968-1.302-8.589-2.468-.402-.179-.775-.325-.83-.325-.056 0-.229.061-.385.136",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.464 11.968c-.128.127-.128.127-.128 1.248v1.12h-1.12c-1.12 0-1.12 0-1.248.127l-.128.128v2.818l.127.127c.128.128.128.128 1.249.128h1.12v1.12c0 1.12 0 1.12.127 1.248l.128.128h2.818l.127-.128c.128-.127.128-.128.128-1.248v-1.12h1.12c1.12 0 1.12 0 1.248-.128l.128-.127V14.59l-.128-.127c-.127-.128-.128-.128-1.248-.128h-1.12v-1.12c0-1.12 0-1.12-.128-1.248l-.127-.128H14.59z",
    clipRule: "evenodd"
  })));
};
export default SvgHealthCare;